import { useRef, useState, useEffect } from 'react'
import './register.css'
import { Link } from 'react-router-dom'
import Axios from 'axios'
import Logo from "../../assets/Alien-Blank.png"



const USER_REGEX = /^[A-z][A-z0-9-_]{3,23}$/;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;

const Register = () => {
  const userRef = useRef();
  const errRef = useRef();

  const [user, setUser] = useState('');
  const [validName, setValidName] = useState(false);
  const [userFocus, setUserFocus] = useState(false);

  const [pwd, setPwd] = useState('');
  const [validPwd, setValidPwd] = useState(false);
  const [pwdFocus, setPwdFocus] = useState(false);

  const [matchPwd, setMatchPwd] = useState('');
  const [validMatch, setValidMatch] = useState(false);
  const [matchFocus, setMatchFocus] = useState(false);

  const [errMsg, setErrMsg] = useState('');
  const [success, setSuccess] = useState(false);
  const [registrationEnabled, setRegistrationEnabled] = useState(true);
  const [checkingRegistration, setCheckingRegistration] = useState(true);

  useEffect(() => {
      userRef.current.focus();
  }, [])

  useEffect(() => {
      const loadRegistrationStatus = async () => {
          try {
              const response = await Axios.get('https://api.alientrader.cards/auth/register-status');
              setRegistrationEnabled(Boolean(response.data.enabled));
          } catch (error) {
              console.error('Error loading registration status:', error);
          } finally {
              setCheckingRegistration(false);
          }
      };

      loadRegistrationStatus();
  }, [])

  useEffect(() => {
      setValidName(USER_REGEX.test(user));
  }, [user])

  useEffect(() => {
      setValidPwd(PWD_REGEX.test(pwd));
      setValidMatch(pwd === matchPwd);
  }, [pwd, matchPwd])

  useEffect(() => {
      setErrMsg('');
  }, [user, pwd, matchPwd])

  const handleSubmit = async (e) => {
      e.preventDefault();
      if (!registrationEnabled) {
        setErrMsg('Public registration is currently disabled.');
        return;
      }
      try {
        const response = await Axios.post('https://api.alientrader.cards/auth/register',
            JSON.stringify({ user, pwd }),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            }
        );
        console.log(response?.data);
        console.log(response?.accessToken);
        console.log(JSON.stringify(response))
        setSuccess(true);
        //clear state and controlled inputs
        //need value attrib on inputs for this
        setUser('');
        setPwd('');
        setMatchPwd('');
    } catch (err) {
        if (!err?.response) {
            setErrMsg('No Server Response');
        } else if (err.response?.status === 409) {
            setErrMsg('Username Taken');
        } else if (err.response?.status === 403) {
            setErrMsg(err.response?.data?.message || 'Public registration is currently disabled.');
        } else {
            setErrMsg('Registration Failed')
        }
        errRef.current.focus();
    }
  }

  return (
    <>
      {success ? (
        <div>
          <h1>Success!</h1>
          <p><Link to="/login">Sign In</Link></p>
        </div>
      ) : (
        <div className='register'>
          <br />
          <div className='register-logo'>
            <Link to="/"><img src={Logo} alt="Alien Trader" /></Link>
          </div>
          <h1>Alien Trader Co</h1>
          <div  className='register-box shadow-sm'>
          <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
            {!checkingRegistration && !registrationEnabled && (
              <p className="errmsg">Public registration is currently disabled. Please contact an admin.</p>
            )}
             <h2>Please Register</h2>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                id="username"
                ref={userRef}
                autoComplete="off"
                onChange={(e) => setUser(e.target.value)}
                value={user}
                required
                aria-invalid={validName ? "false" : "true"}
                aria-describedby="uidnote"
                onFocus={() => setUserFocus(true)}
                onBlur={() => setUserFocus(false)}
                placeholder='Username'
              />
              <p id="uidnote" className={userFocus && user && !validName ? "instructions" : "offscreen"}>
                4 to 24 characters.<br />
                Must begin with a letter.<br />
                Letters, numbers, underscores, hyphens allowed.
              </p>
              <input type="text" placeholder='Email' />
              <input
                type="password"
                id="password"
                onChange={(e) => setPwd(e.target.value)}
                value={pwd}
                required
                aria-invalid={validPwd ? "false" : "true"}
                aria-describedby="pwdnote"
                onFocus={() => setPwdFocus(true)}
                onBlur={() => setPwdFocus(false)}
                placeholder='Password'
              />
              <p id="pwdnote" className={pwdFocus && !validPwd ? "instructions" : "offscreen"}>
                8 to 24 characters.<br />
                Must include uppercase and lowercase letters, a number and a special character.<br />
                Allowed special characters: <span aria-label="exclamation mark">!</span> <span aria-label="at symbol">@</span> <span aria-label="hashtag">#</span> <span aria-label="dollar sign">$</span> <span aria-label="percent">%</span>
              </p>
              <input
                type="password"
                id="confirm_pwd"
                onChange={(e) => setMatchPwd(e.target.value)}
                value={matchPwd}
                required
                aria-invalid={validMatch ? "false" : "true"}
                aria-describedby="confirmnote"
                onFocus={() => setMatchFocus(true)}
                onBlur={() => setMatchFocus(false)}
                placeholder='Confrim Password'
              />
              <p id="confirmnote" className={matchFocus && !validMatch ? "instructions" : "offscreen"}>
                Must match the first password input field.
              </p>
              <span>Already registered? <Link to="/login">Login</Link></span>
              <button disabled={checkingRegistration || !registrationEnabled}>Register</button>
            </form>
          </div>
          <br />
          <br />
        </div>
      )}
    </>
  )
}

export default Register
